export default "https://cdn-gra.amplement.io/statics/images/placeholder/placeholderNotification@2x.png";